import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';

export const FinanceInstitutionDropdown = (props) => {
  const { t } = useTranslation();
  const [institutions, setInstitutions] = useState([]);

  useEffect(() => {
    if (props.institutions != null) {
      setInstitutions(props.institutions);
      return;
    }
    Fetch('api/data/finance.institutions', 'GET', null,
      (data) => setInstitutions(data || []),
      () => {}
    );
  }, [props.institutions]);

  return (
    <select value={props.selected || ''} onChange={props.onChange} style={props.style}>
      {props.showAll && <option value="">{props.allLabel || '—'}</option>}
      {institutions.map(inst => (
        <option key={inst._id} value={inst.name}>{t(inst.name, { defaultValue: inst.name })}</option>
      ))}
    </select>
  );
};

export default FinanceInstitutionDropdown;
